import request from '@/utils/request'

// 根据栏目ID获取子栏目树
export function getColumnTreeList(query) {
  return request({
    url: '/api/portal/getColumnTreeList',
    method: 'get',
    params: query
  })
}

// 轮播图
export function getIndexPicDOList(query) {
  return request({
    url: '/api/portal/getIndexPicDOList',
    method: 'get',
    params: query
  })
}

// 获取文章列表
export function getNewsDOList(query) {
  return request({
    url: '/api/portal/getNewsDOList',
    method: 'get',
    params: query
  })
}

// 获取文章详情
export function getNewsDetail(cid) {
  return request({
    url: '/api/portal/getNewsDOInfo/' + cid,
    method: 'get'
  })
}

// 获取字典类型
export function getDictByType(type) {
  return request({
    url: '/api/portal/getDictByType/' + type,
    method: 'get'
  })
}

//提交意见反馈
export function addSaveIdea(data) {
  return request({
    url: '/api/portal/saveIdea',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js